module.exports = __webpack_public_path__ + "img/wupinshenqing.68b3c11a.png";